module.exports = "\r\n<div mat-dialog-content class=\"w-timepicker-dialog\">\r\n    <w-time [color]=\"color\" [userTime]=\"userTime\" (onRevert)=\"revert()\" (onSubmit)=\"submit()\"></w-time>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/time-control/w-time-dialog/w-time-dialog.component.html
// module id = 1598
// module chunks = 0